<div class="measure-wrapper">
  <div class="grid-x">

    <div class="cell small-8">
      <mat-checkbox *ngIf="inputType === 'checkbox'" (change)="changeMeasure($event)" [value]="form.controls[formField].value" [checked]="form.controls[formField].value" color="primary">
        <span [innerHTML]="textPrefix + measure | translate"></span>
        <span class="label" *ngIf="showBadge === true" [innerHTML]="textPrefix + 'recommend' | translate"></span>
      </mat-checkbox>

      <mat-radio-group>
        <mat-radio-button *ngIf="inputType === 'radio'" [value]="value" (change)="changeMeasure($event)" [checked]="form.controls[formField].value === value" [name]="measure" color="primary">
          <span [innerHTML]="textPrefix + measure | translate"></span>
          <span class="label" *ngIf="showBadge === true" [innerHTML]="textPrefix + 'recommend' | translate"></span>
          <span class="label alert" (click)="toggleShowText()" *ngIf="alert === true" [innerHTML]="textPrefix + 'notrecommend' | translate"></span>
        </mat-radio-button>
      </mat-radio-group>

      <mat-slide-toggle *ngIf="inputType === 'switch'" color="primary" [checked]="form.controls[formField].value" (change)="changeMeasure($event)">
        <span [innerHTML]="textPrefix + measure | translate"></span>
      </mat-slide-toggle>

    </div>

    <div class="cell small-4">
      <div class="grid-x">
        <div class="cell small-12 medium-9 large-10 text-right saving-bar-wrapper">
          <span *ngIf="saving !== null" role="img" [attr.aria-label]="saving" [class.saving-bar]="saving != 0" [class.primary]="saving < 0 && savingUnit === 'kwh'"
             [class.green]="saving < 0 && savingUnit === 'co2'"
             [class.no-saving]="saving > 0" [style.width]="width"></span>
          <strong>{{saving | number: savingUnit === 'co2'? '1.0-1' : '1.0-0'}}</strong>
        </div>
        <div class="cell small-12 medium-3 large-2 text-right">
          <button type="button" class="help-button" [attr.aria-expanded]="showText" [attr.aria-controls]="measure + '-help'" [attr.aria-label]="'arialabel.toggle.help' | translate" (click)="toggleShowText()">
            <i class="icon-help-circle"
               [class.primary]="internalPortal && showBadge && (form.controls[formField].value === value || form.controls[formField].value === true)"
               [class.warning]="hint && ((inputType === 'radio' && form.controls[formField].value === value) || (inputType !== 'radio' && form.controls[formField].value === true))"
               [class.alert]="alert === true && form.controls[formField].value === value">
            </i>
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="callout lighter-gray" *ngIf="showText">
    <button type="button" class="close" [attr.aria-label]="'arialabel.close' | translate" (click)="toggleShowText()"><i class="icon-x"></i></button>
    <p [id]="measure + '-help'" [innerHTML]="textPrefix + measure + textPostfix + '.text' | translate"></p>
    <p class="success" *ngIf="showBadge === true" [innerHTML]="textPrefix + measure + textPostfix + '.empfehlung' | translate"></p>
    <p class="warning" *ngIf="hint === true" [innerHTML]="(textPrefix + measure + textPostfix + '.hinweis.' + recommend) | translate"></p>
    <p class="alert" *ngIf="alert === true" [innerHTML]="textPrefix + measure + textPostfix + '.warnung' | translate"></p>
  </div>
</div>
